import React, { useContext, useEffect, useState } from "react";

// Custom Components
import DataCentricPage from "@/views/DataCentric/DataCentricPage";
import modelComments from "@/models/komentari";
import { Permissions  } from "@/lib/permissions";

import UserContext from "@/components/UserContext/UserContext";
import CommentDialog from "./CommentDialog";

function CommentsPage() {
  const userContext = useContext(UserContext);

  const [ initialSelectedId, setInitialSelectedId] = useState<number | undefined>(undefined);

  const allowEdit = userContext?.hasAnyPermission([Permissions.HGSSMod, Permissions.HPSMod]);

  const form = userContext?.hasAnyPermission([Permissions.HGSSMod]) ? "update-hgss"
  : userContext?.hasAnyPermission([Permissions.HPSMod]) ? "update-hps" 
  : "default";

  useEffect(() => {
    checkURL();
  }, []);

  const checkURL = () => {
    const id = new URLSearchParams(window.location.search).get("id");

    if (id) {
      setInitialSelectedId(parseInt(id, 10));
    }
  }

  const hasAdminRights = userContext?.hasAnyPermission([Permissions.HGSSMod, Permissions.HPSMod]);

  return (
    <DataCentricPage
      needPermission={[Permissions.HGSSRead, Permissions.HPSRead, Permissions.HPSSharedView]}
      
      primaryModel={modelComments}
      primaryTitleToken={ hasAdminRights ? "titles.komentari" : "titles.komentari_moji"}
      primaryView={hasAdminRights ? "admin" : "reg_or_hps"}
      primaryAllowView={hasAdminRights}
      primaryAllowEdit={allowEdit}
      primaryDialogComponent={CommentDialog}
      primaryDialogForm={form}
      primaryInitialSelectedId={initialSelectedId}

      secondaryModel={modelComments}
      secondaryTitleToken="titles.komentari_objekt"
      secondaryView={userContext?.hasAnyPermission([Permissions.HGSSMod, Permissions.HPSMod]) ? "related_komentari" : "my_related_komentari"}
      secondaryAllowView={hasAdminRights}
      secondaryAllowEdit={allowEdit}
      secondaryDialogComponent={CommentDialog}
      secondaryDialogForm={form}

      baseRecordPath={modelComments.apiPath}
      childRecordRelativePath="object"
      geomRelativePath=""

      mapId={4}
      mapModel={modelComments}
      
      />
  );
}

export default CommentsPage;
